import * as React from "react";
import {
	createBottomTabNavigator,
	BottomTabScreenProps,
} from "@react-navigation/bottom-tabs";
import Home from "./Home";
import BottomTabNav from "../../components/BottomTabNav";
import Settings from "./Settings";
import ID from "./ID/ID";
import ContentStack from "./ContentStack/ContentStack";
import SignInWebView from "./SignInWebView";
import ServicesStack from "./ServicesStack";
import DiscountStack from "./DiscountStack.tsx";
import TermsOfService from "../BoardingStack/NewUserStack/TermsOfService";
import TermsOfServiceHeader from "../BoardingStack/NewUserStack/TermsOfServiceHeader";
import DefaultHeader from "./DefaultHeader";
import { USE_MOCK_API } from "../../mocks";

export type HomeStackNavParamList = {
	Home: undefined;
	Settings: any;
	Card: undefined;
	Discounts: any;
	SignIn: any;
	Services: any;
	Content: any;
	ToS: any;
};
const HomeStackNav = createBottomTabNavigator<HomeStackNavParamList>();

export type HomeScreenProps = BottomTabScreenProps<
	HomeStackNavParamList,
	"Home"
>;

export type SettingsScreenProps = BottomTabScreenProps<
	HomeStackNavParamList,
	"Settings"
>;

export type SignInWebViewScreenProps = BottomTabScreenProps<
	HomeStackNavParamList,
	"SignIn"
>;

const HomeStack = () => {
	return (
		<HomeStackNav.Navigator
			// The mock web build exists to show the card, so it opens on that tab
			// instead of Home. The real app still starts on Home.
			initialRouteName={USE_MOCK_API ? "Card" : "Home"}
			screenOptions={{
				header: props => {
					if (props.route.name === "ToS") return <TermsOfServiceHeader />;
					return <DefaultHeader />;
				},
			}}
			tabBar={props => {
				// if (props.state.index === 4 || props.state.index === 5) {
				// 	return null;
				// }
				return <BottomTabNav {...props} />;
			}}
		>
			<HomeStackNav.Screen
				name="Home"
				component={Home}
				options={{ tabBarLabel: "Início" }}
			/>
			<HomeStackNav.Screen
				name="Card"
				component={ID}
				options={{ tabBarLabel: "Carteira" }}
			/>
			<HomeStackNav.Screen
				name="Discounts"
				component={DiscountStack}
				options={{ tabBarLabel: "Descontos" }}
			/>
			<HomeStackNav.Screen
				name="Settings"
				component={Settings}
				options={{ tabBarLabel: "Opções" }}
			/>
			<HomeStackNav.Screen
				name="Content"
				component={ContentStack}
				options={{ tabBarLabel: "Conteúdo" }}
			/>
			<HomeStackNav.Screen
				name="Services"
				component={ServicesStack}
				options={{ tabBarLabel: "Serviços" }}
			/>

			<HomeStackNav.Screen name="SignIn" component={SignInWebView} />
			<HomeStackNav.Screen name="ToS" component={TermsOfService} />
		</HomeStackNav.Navigator>
	);
};

export default HomeStack;
